import classNames from 'classnames';
import { DefaultCardProps } from './default-card-props';
import { useDefaultCardStyles } from './default-card-styles';

export const DefaultCard = ({
  onClick,
  isSelected,
  children,
  className,
  isClickable = true
}: DefaultCardProps) => {
  const classes = useDefaultCardStyles();

  return (
    <>
      <div
        onClick={onClick}
        className={classNames(
          classes.cardContainer,
          isSelected ? classes.cardSelected : undefined,
          isClickable ? classes.cardClickable : undefined,
          className
        )}
      >
        {children}
      </div>
    </>
  );
};
